import type { UserConsentItem } from '../../../redux/apis/consents.api';

export const findAiConsent = (consents?: UserConsentItem[]) =>
  consents?.find((consent) => consent.consentKey === 'AI_DATA_SHARING');
